export const CREATE_CUSTOM_ATTRIBUTE_OPTION_REQUESTED = 'CREATE_CUSTOM_ATTRIBUTE_OPTION_REQUESTED';
export const CREATE_CUSTOM_ATTRIBUTE_OPTION_SUCCEEDED = 'CREATE_CUSTOM_ATTRIBUTE_OPTION_SUCCEEDED';
